export default __webpack_public_path__ + "static/media/151.3144c583.svg";